import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button, Stack, Alert,
  CircularProgress, MenuItem,
} from "@mui/material";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";

// Valeurs de l'enum backend WellnessType
const TYPES = [
  { id: "HEART_COHERENCE", name: "Cohérence cardiaque (sessions)" },
  { id: "STEPS", name: "Pas" },
  { id: "MEDITATION", name: "Méditation (minutes)" },
];

const Wellness = () => {
  const [userId, setUserId] = React.useState("");
  const [summary, setSummary] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [type, setType] = React.useState("STEPS");
  const [value, setValue] = React.useState("");
  const notify = useNotify();

  const loadSummary = async () => {
    if (!userId.trim()) return;
    setLoading(true);
    try {
      const { json } = await httpClient(
        `${API_BASE_URL}/wellness/${encodeURIComponent(userId)}/summary`
      );
      setSummary(json);
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const log = async () => {
    if (!userId.trim() || !value) return;
    try {
      // type & value sont des @RequestParam (pas de body JSON)
      const qs = new URLSearchParams({ type, value: String(Number(value)) });
      await httpClient(`${API_BASE_URL}/wellness/${encodeURIComponent(userId)}/log?${qs}`, {
        method: "POST",
      });
      notify("Entrée bien-être enregistrée", { type: "success" });
      setValue("");
      loadSummary();
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <HealthAndSafetyIcon /> Bien-être (par utilisateur)
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Récapitulatif 7 jours et ajout d'entrée bien-être pour un utilisateur donné.
        Backend : /api/v1/wellness/{"{userId}"}/summary &amp; /log.
      </Alert>
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Stack direction="row" spacing={2} alignItems="center">
            <TextField size="small" label="ID utilisateur" value={userId}
              onChange={(e) => setUserId(e.target.value)} />
            <Button variant="contained" onClick={loadSummary}
              disabled={loading || !userId.trim()}>
              {loading ? <CircularProgress size={18} /> : "Récap 7 jours"}
            </Button>
          </Stack>
          {summary && (
            <Box component="pre" sx={{
              bgcolor: "#f5f7fa", p: 2, borderRadius: 1,
              fontSize: 12, mt: 2, maxHeight: 400, overflow: "auto",
            }}>
              {JSON.stringify(summary, null, 2)}
            </Box>
          )}
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>Enregistrer une entrée</Typography>
          <Stack direction="row" spacing={1}>
            <TextField select size="small" label="Type" value={type}
              onChange={(e) => setType(e.target.value)} sx={{ minWidth: 150 }}>
              {TYPES.map((t) => <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>)}
            </TextField>
            <TextField size="small" type="number" label="Valeur" value={value}
              onChange={(e) => setValue(e.target.value)} />
            <Button variant="outlined" onClick={log}
              disabled={!userId.trim() || !value}>
              Logger
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default { list: Wellness };
